import { useMsal } from "@azure/msal-react";
import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { USER_AUTH_TYPE } from "../../enums/user-auth-type.enum";
import { msalConfig } from "../../config/msalConfig";
import { createMsalInstance } from "../../utils/create-msal-instance";

type SuccessRegistrationModalProps = {
  show: boolean;
  handleClose: () => void;
  program: string;
};
export default function SuccessRegistrationModal({
  show,
  handleClose,
  program
}: SuccessRegistrationModalProps) {
  const { instance } = useMsal();

  const acknowledge = async () => {
    localStorage.setItem('successRegistrationProgram', program);
    msalConfig.auth.redirectUri =
      process.env.REACT_APP_MSAL_REGISTRATION_REDIRECT_URI || "";
    msalConfig.auth.postLogoutRedirectUri = `${process.env.REACT_APP_BASE_URL}/success-registration`;
    const msalInstance = await createMsalInstance();
    localStorage.removeItem("registrationToken");
    msalInstance.logoutRedirect({
      authority: `${process.env.REACT_APP_MSAL_AUTHORITY}/${USER_AUTH_TYPE.COMARCH_CUSTOMER}`,
    });
  };

  return (
    <Modal show={show}>
      <Modal.Header closeButton>
        <Modal.Title>Success!</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        You've successfully registered and enrolled for the new{" "}
        {program}{" "}experience. We are completing your profile setup. We will notify
        you once it's ready for you to login.
      </Modal.Body>
      <Modal.Footer>
        <div className="flex justify-between w-full">
          <Button variant="primary" className="flex-1" onClick={acknowledge}>
            Acknowledge
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
}
